import script from "./pageNewsV2.vue?vue&type=script&setup=true&lang=js"
export * from "./pageNewsV2.vue?vue&type=script&setup=true&lang=js"

import "./pageNewsV2.vue?vue&type=style&index=0&id=9353c6f0&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9353c6f0"]])

export default __exports__